module.exports = __webpack_public_path__ + "static/media/2 7 Ordkjedetest-Starter-testen.8e24de16.mp3";